import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReportIcon from "@mui/icons-material/Report";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const LoadingStatus = ({ loading, displayText }) => {
	return (
		<Grid display="flex" sx={{ flexGrow: 1 }} alignItems="center">
			<Grid item sx={{ flexGrow: 1 }}>
				<Typography
					variant="subtitle1"
					sx={{ marginRight: 1, color: "white" }}
					textAlign="right"
				>
					{loading === "true"
						? displayText.loaded
						: loading === "false"
						? displayText.loading
						: displayText.error}
				</Typography>
			</Grid>
			<Grid item xs={5} md={5} lg={5.5} display="flex">
				{loading === "true" ? (
					<CheckCircleIcon htmlColor="white" fontSize="large" />
				) : loading === "false" ? (
					<CircularProgress sx={{ color: "white" }} />
				) : (
					<ReportIcon color="error" fontSize="large" />
				)}
			</Grid>
		</Grid>
	);
};

export default LoadingStatus;
